// extracted by mini-css-extract-plugin
module.exports = {"search":"ArticleSearch_search__x9VNB"};